module.exports = __webpack_public_path__ + "assets/hetong.7724b43c5919198c2fb7087f2e18e13c.png";